import React, { useEffect, useState, useRef } from "react";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator, FilterService } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import axios from "../../datasource/axios";
import { CPPREQUESTLIST_URL, DELETECPPREQUEST_URL } from "../../constants";
import { hideLoader, showLoader } from "../../datasource/msal";
import "./CppoCodeList.css";
import CPPRequestDetails from './CppoCodeListDetails';
import CPPRequestFormDetails from './CppoEditRequest';
import CPPActionModal from "./CppoActionDialog";
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { InputIcon } from "primereact/inputicon";
import { IconField } from 'primereact/iconfield';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from 'primereact/tooltip';

export const CppoRequestList = (props: any) => {
  const ASKNOW_BASE_URL =  process.env.REACT_APP_ASKNOW_API_URI as string;
  const [cppCodeList, setCppCodeList] = useState<any[]>([]);
  const [cppCodeListFilterdData, setCppCodeListFilteredData] = useState<any[]>([]);
  const [filteredRows, setFilteredRows] = useState<any[]>([]);
  const [first, setFirst] = useState(0);
  const [actionMode, setActionMode] = useState('');
  const [requestDetails, setRequestDetails] = useState({});
  const [visible, setVisible] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState<boolean>(false);
  const [actionModalVisible, setActionModalVisible] = useState<boolean>(false);
  const [rowId, setRowId] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(0);
  const dateTime = new Date();
  const timestamp = getFormattedDate(dateTime);
  const [filters, setFilters] = useState<any>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submitterName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    requestedNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    askNowTicketNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    defaultAliasName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    clientReportingAliasName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    approvalStatus: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    active: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const dt = useRef(null);
  const [deleteRecordDialog, setDeleteRecordDialog] = useState(false);
  const [record, setRecord] = useState("");
  const toast = useRef<any>(null);
  const [selectedstatus, setSelectedStatus] = useState({ name: 'Pending', code: '2' });
  const statuslist = [
    { name: 'All', code: '0' },
    { name: 'Draft', code: '1' },
    { name: 'Pending', code: '2' },
    { name: 'Partial Approval', code: '3' },
    { name: 'Approved', code: '4' },
    { name: 'Partial Rejected', code: '5' },
    { name: 'Rejected', code: '6' }
  ];

  const getSeverity = (status: string) => {
    switch (status) {
      case 'Approved':
        return 'success';

      case 'Rejected':
        return 'danger';

      case 'Partial Rejected':
        return 'danger';

      default:
        return 'info';
    }
  };
  function Callback(mappings: any) {
   setCppCodeList(mappings);
   // handleStatusFilter({ name: 'All', code: '0' });
    if (selectedstatus.name !== 'All') {
      setCppCodeListFilteredData(mappings.filter((item: any) => item.approvalStatus === selectedstatus.name));
      setFilteredRows(mappings.filter((item: any) => item.approvalStatus === selectedstatus.name));
    }
    else {
      setCppCodeListFilteredData(mappings);
      setFilteredRows(mappings);
    }
  }

  useEffect(() => {
    setLoading(false);
    initFilters("");
    //get submitter
    fetchDashboard();
  }, []);

  useEffect(() => {
    handleStatusFilter(selectedstatus);
  }, [cppCodeList]);


  const askNowLink = (reqId: any) => {
    let ticketUrl = ASKNOW_BASE_URL + "nav_to.do?uri=sc_req_item.do?sys_id=[ticketNumber]";
    return ticketUrl.replace("[ticketNumber]", reqId);
  }

  function generateAskNowLink(cppRequest: any) {
    if (!cppRequest.askNowRequestId) {
      return "";
    }
    var link = askNowLink(cppRequest.askNowRequestId);
    return link;
  }

  const askNowLinkTemplate = (cppRequest: any) => {
    if (!cppRequest.askNowTicketNumber) {
      return <span>&nbsp;</span>
    }

    return (
      <>
        {
          <div>
            <a href={askNowLink(cppRequest.askNowRequestId)} target="_blank" rel="noreferrer">
              {cppRequest.askNowTicketNumber}
            </a>
          </div>
        }
      </>
    );
  };

  const linkTemplate = (cppRequest: any) => {
    if (!cppRequest.requestedNumber) {
      return <span>&nbsp;</span>
    }

    let id = cppRequest.id;

    return (
      <>
        {
          <div>
            <Button type="button" label={cppRequest.requestedNumber} onClick={() => showDetails(id)} className="link-button" />
          </div>
        }
      </>
    );
  };

  const CPPDetails = (val: any) => {
    setVisible(val);
  }

  const CPPActions = (val: any) => {
    setActionModalVisible(val);
  }

  const CPPEditForm = (val: any, changeMade: any) => {
    setEditFormVisible(val);
    if (!val && changeMade) {
     // toast.current.show({ severity: 'success', summary: 'Success', detail: 'CPP Request saved!', life: 10000 });
      //initFilters(status);
      fetchDashboard();
    } else {
    }

  }

  const showDetails = (cppRequestId: number) => {
    setVisible(true);

    var prIdx = cppCodeList.findIndex((v: { [x: string]: any; }) => v["id"] === cppRequestId);

    if (prIdx < 0) {
      return 0;
    } else {
      var details = cppCodeList[prIdx];
      setRequestDetails(details);
    }
  }

  const showActionModal = (rowId: number, actionType: string) => {
    setActionModalVisible(true);
    setActionMode(actionType);
    setRowId(rowId);

  }

  const editForm = (cppRequestId: number) => {
    setVisible(false);
    var prIdx = cppCodeList.findIndex((v: { [x: string]: any; }) => v["id"] === cppRequestId);

    if (prIdx < 0) {
      return 0;
    } else {
      var details = cppCodeList[prIdx];
      setEditFormVisible(true);
      setRequestDetails(details);
    }

  };

  const reasonTemplate = (rowData: any) => {
    return (
      <>
      <Tooltip target=".custom-target-icon" />
      <i className="custom-target-icon"
         data-pr-position="right"
         data-pr-at="right+5 top"
         data-pr-my="left center-2"
        data-pr-tooltip={rowData.comment}
        style={{ fontSize: '1.5rem',
        cursor: 'pointer',
        height: '5rem'      
       }}>
      <Tag value={rowData.approvalStatus} severity={getSeverity(rowData.approvalStatus)} />
      </i>
      </>
    );
  };

  function setRequestInfo(row: number, submitted: any) {
    setRowId(row);
    setIsSubmitted(submitted);
  }

  const deleteCppRequestListByRequestId = async () => {

    let BASE_URL =  process.env.REACT_APP_API_URI;
    let url = BASE_URL + DELETECPPREQUEST_URL + "/" + rowId + "/" + isSubmitted;

    let successMsg = "";
    let errorMsg = "";
    if (isSubmitted) {
      successMsg = "CPP Request cancelled!";
      errorMsg = "Unable to cancel CPP Request";
    } else {
      successMsg = "CPP Request deleted!";
      errorMsg = "Unable to delete CPP Request";
    }
    hideDeleteRecordDialog();
    const res: any = await new Promise((resolve, reject) => {
      try {
        showLoader();
        axios.postRequest(url)
          .then((res: any) => {
            hideLoader();
            resolve(res);
          })
          .catch((err: any) => {
            resolve(err);
          });
      } catch (error: any) {
        reject(error);
      }
    });
    if (res.status == "Success") {
      toast.current.show({ severity: 'success', summary: 'Success', detail: successMsg, life: 10000 });
      await sleep(1000);
      fetchDashboard();
    } else {
      toast.current.show({ severity: 'error', summary: 'Error', detail: errorMsg, life: 10000 });
    }
  };

  const sleep = async (milliseconds: number) => {
    await new Promise(resolve => {
      return setTimeout(resolve, milliseconds)
    });
  };

  const getCppRequestListByUserid = () => {

    let BASE_URL =  process.env.REACT_APP_API_URI;
    let url = BASE_URL + CPPREQUESTLIST_URL;

    return new Promise((resolve, reject) => {
      try {
        axios.getRequest(url)
          .then((res: any) => {
            hideLoader();
            resolve(res.data);
          })
          .catch((err: any) => {
            resolve(err);
          });
      } catch (error: any) {
        reject(error);
      }
    });
  };

  const fetchDashboard = async () => {
    const response: any = await getCppRequestListByUserid();
    const mappings = response?.responseMappings ?? [];
    setCppCodeList(mappings);
    setCppCodeListFilteredData(mappings);
    setFilteredRows(mappings);
    //load initial filtered values for export 
    const arr: any[] = [];

    mappings.forEach((element: any) => {
      let status = element.approvalStatus;
      if (status.includes('Pending') || status.includes('Partial')) {
        arr.push(element);
      }
    });
    //setFilteredRows(arr);
  }


  const clearFilter = () => {
    initFilters(null);
  };

  FilterService.register(
    "approvalFilter",
    (fieldValue, query) => fieldValue === null
  );

  const initFilters = (pendingFilter?: any) => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      submitterName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      requestedNumber: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      askNowTicketNumber: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      defaultAliasName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      clientReportingAliasName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      approvalStatus: {
        operator: FilterOperator.AND,
        constraints: [{ value: pendingFilter, matchMode: FilterMatchMode.IN }],
      },
      active: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };

  const updateFilteredValues = (filteredData: any) => {
    setFilteredRows(filteredData);
  }

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const value = e.target.value;
      let _filters = { ...filters };

      _filters["global"]["value"] = value;

      setFilters(_filters);
      setGlobalFilterValue(value);
    } catch (e: any) {
      e.stack
        .split("\n")
        .slice(1)
        .map((r: string) => r.match(/\((?<file>.*):(?<line>\d+):(?<pos>\d+)\)/))
        .forEach((r: { groups: { file: any; line?: any; pos?: any } }) => {
          if (r && r.groups && r.groups.file.substr(0, 8) !== "internal") {
            const { file, line, pos } = r.groups;
            //const f = fs.readFileSync(file, 'utf8').split('\n')
            alert(line + ":" + pos);
            // alert(f[line - 1].trim());
          }
        });
    }
  };

  const csvColNames = [
    "Created By",
    "RITM",
    "Client Code",
    "Default Alias Name",
    "Client Reporting Alias Name",
    "Status",
    "Active",
    "Legal Entity",
    "Client Type",
    "New Parent Needed (EIG)",
    "Parent in Total Clients (EIG)",
    "New Parent Needed (Hyperion)",
    "Parent in Total Clients (Hyperion)",
    "Total Clients - By Manager",
    "Total Clients - Contracted by Country",
    "Segment Attribute",
    "Vertical Attribute",
    "Geo Attribute",
    "Client Portfolio",
    "Allocations - Segment",
    "Engage Allocations - Site Allocations",
    "Engage Allocations - Country Allocations",
    "Engage Allocations - Regional Allocations",
    "Engage Allocations - CMS/CGS Allocations",
    "Engage Allocations - Engage Segment Allocations",
    "At Home Allocations - Site Allocations",
    "At Home Allocations - Segment Allocations",
    "FCR Allocations - Site Allocations",
    "FCR Allocations - Country Allocations",
    "Corporate Allocations - Corp Allocations",
    "Corporate Allocations - Alternate Client Rollups 1",
    "Corporate Allocations - Alternate Client Rollups 2",
    "Corporate Allocations - Hyper Growth Client",
    "Timezone",
    "Request Start Date",
    "Created Date",
    "Updated By",
    "Updated Date"
  ];

  const status = [
    "Pending",
    "Partial Approval",
    "Partial Rejected"
  ];

  const rowColNames = [
    "submitterName",
    "askNowTicketNumber",
    "requestedNumber",
    "defaultAliasName",
    "clientReportingAliasName",
    "approvalStatus",
    "active",
    "legalEntity",
    "clientType",
    "newParentNeededEig",
    "parentInTotalClientsEig",
    "newParentNeededHyperion",
    "parentInTotalClientsHyperion",
    "totalClientsByManager",
    "contractByCountry",
    "segmentAttribute",
    "verticalAttribute",
    "geoAttribute",
    "clientPortfolio",
    "segmentAttributeAlloc",
    "siteAllocations",
    "countryAllocations",
    "regionalAllocations",
    "cmsCgsAllocations",
    "engageSegmentAllocations",
    "siteAllocationsAtHome",
    "segmentAllocationsAtHome",
    "siteAllocationsFcr",
    "countryAllocationsFcr",
    "corpAllocations",
    "alternateClientRollups1",
    "alternateClientRollups2",
    "hyperGrowthClient",
    "timezone",
    "requestedStartDate",
    "createdDate",
    "updatedBy",
    "updatedDate"
  ];

  const actionBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        {!rowData.isSubmitted && <Button icon="pi pi-pencil" rounded outlined className="actionicon" tooltip="Edit" onClick={() => editForm(rowData.id)} />}
        {props?.showActions && rowData.approvalStatus === "Draft" && <Button icon="pi pi-trash" rounded outlined className="actionicon" severity="danger" tooltip="Delete" onClick={() => confirmDeleteRecord(rowData)} />}
        {(props?.showActions && (rowData.approvalStatus === "Pending" || rowData.approvalStatus === "Partial Approval" || rowData.approvalStatus === "Partial Rejected")) && <Button icon="pi pi-check" rounded outlined className="actionicon" severity="success" tooltip="Approve" onClick={() => showActionModal(rowData.id, 'Approve')} />}
        {(props?.showActions && (rowData.approvalStatus === "Pending" || rowData.approvalStatus === "Partial Approval" || rowData.approvalStatus === "Partial Rejected")) && <Button icon="pi pi-times" rounded outlined className="actionicon" severity="danger" tooltip="Reject" onClick={() => showActionModal(rowData.id, 'Reject')} />}
      </React.Fragment>
    );
  };

  const confirmDeleteRecord = (record: any) => {
    setRecord(record?.requestedNumber);
    setDeleteRecordDialog(true);
    setRequestInfo(record.id, record.isSubmitted);
  };

  const exportCSV = () => {
    // @ts-ignore: Object is possibly 'null'.
    let exportFile = "";
    if(filteredRows.length > 0)
    {
    if (filteredRows) {
      exportFile = convertToCSV(filteredRows);
    } else {
      exportFile = convertToCSV(cppCodeList);
    }
    var fileName = "CPPRequestList-" + timestamp;
    var uri = "data:text/csv;charset=utf-8," + escape(exportFile);
    var link = document.createElement("a");
    link.href = uri;
    link.className = "hidden-link";
    link.download = fileName + ".csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  else{
    toast.current.show({ severity: 'warn', summary: 'Warn', detail: 'No Records to Export', life: 10000 });
  }
  };

  function getFormattedDate(date: Date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");

    return month + "/" + day + "/" + year;
  }

  function convertToCSV(tableData: any, delimiter = ",") {
    if (!Array.isArray(tableData) || !tableData.length) {
      throw new Error(
        "Table data should be a non-empty array of column/value rows"
      );
    }

    var rows = tableData.map((rowData: any) => {
      var row: any[] = [];
      rowColNames.forEach((name) => {
        if (name == "askNowTicketNumber") {
          var ritm = generateAskNowLink(rowData);
          row.push(ritm);
        } else {
          var escapedName = `"${rowData[name]}"`;
          row.push(escapedName);
        }
        // row.push(rowData[name]);
      });

      return row.join(delimiter);
    });
    rows.unshift(csvColNames.join(delimiter));
    return rows.join("\n");
  }

  function reloadTable() {
    initFilters(status);
    fetchDashboard();
  }

  const renderHeader = () => {
    const value = filters['global'] ? filters['global'].value : '';

    return (
      <div className="headerstyle">
        <div className="hdrstyleone">
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Global Search" />
          </IconField>
        </div>
        <div className="hdrstyletwo">
          Select Status : <Dropdown value={selectedstatus} onChange={(e) => handleStatusFilter(e.value)} options={statuslist} optionLabel="name"
            placeholder="Select Status" className="w-full md:w-14rem" />
        </div>
        <div className="hdrstylethree">
          <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={() => exportCSV()} />
        </div>
      </div>
    );
  };

  const handleStatusFilter = (val: any) => {
    setSelectedStatus(val);
    if (val.name !== 'All') {
      setCppCodeListFilteredData(cppCodeList.filter(item => item.approvalStatus === val.name));
      setFilteredRows(cppCodeList.filter(item => item.approvalStatus === val.name));
    } else {
      setCppCodeListFilteredData(cppCodeList);
      setFilteredRows(cppCodeList);
    }
  }

  const header = renderHeader();

  function sortcolumn(data: any, field: any, order: any) {
    return data.sort((a: any, b: any) => {
      if (a[field] > b[field]) { return order; }
      if (b[field] > a[field]) { return -(order); }
      return 0;
    })
  }

  const hideDeleteRecordDialog = () => {
    setDeleteRecordDialog(false);
  };

  const deleteRecordDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteRecordDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={deleteCppRequestListByRequestId}
      />
    </React.Fragment>
  );

  return (
    <div className="row">
      <h4>CPP Requests</h4>
      <Toast ref={toast} />
      <DataTable
        onValueChange={filteredData => updateFilteredValues(filteredData)}
        exportFilename={"CPPRequestList-" + timestamp}
        ref={dt}
        value={cppCodeListFilterdData}
        tableStyle={{ minWidth: '93rem' }}
        header={header}
        filters={filters}
        globalFilterFields={[
          "submitterName",
          "requestedNumber",
          "askNowTicketNumber",
          "defaultAliasName",
          "clientReportingAliasName",
          "approvalStatus",
          "active",
        ]}
       // loading={loading}
        emptyMessage="No CPP requests found."
        paginator rows={25} rowsPerPageOptions={[5, 10, 25, 50]}
        stripedRows
        showGridlines
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        first={first}
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
      <Column header="Action" body={actionBodyTemplate} exportable={false} style={{ minWidth: '12rem' }}></Column>
        <Column
          field="submitterName"
          header="Created By"
          style={{ textAlign: "center" }}
          sortable
          filter
          filterPlaceholder="Search by Created By"
        ></Column>
        <Column
          field="askNowTicketNumber"
          header="RITM"
          style={{ textAlign: "center" }}
          body={askNowLinkTemplate}
          className="reqDetails"
          sortable
          filter
          filterPlaceholder="Search by RITM"
        ></Column>
        <Column
          field="requestedNumber"
          header="Client Code"
          style={{ textAlign: "center" }}
          body={linkTemplate}
          className="reqDetails"
          sortable
          sortFunction={(e: any) => sortcolumn(e.data, e.field, e.order)}
          filter
          filterPlaceholder="Search by Client Code"
        ></Column>
        <Column
          field="clientReportingAliasName"
          header="Client Reporting Alias Name"
          style={{ textAlign: "center" }}
          sortable
          sortFunction={(e: any) => sortcolumn(e.data, e.field, e.order)}
          filter
          filterPlaceholder="Search by Client Reporting Alias Name"
        ></Column>
        <Column
          field="defaultAliasName"
          header="Default Alias Name"
          style={{ textAlign: "center" }}
          sortable
          sortFunction={(e: any) => sortcolumn(e.data, e.field, e.order)}
          filter
          filterPlaceholder="Search by Default Alias Name"
        ></Column>
        <Column
          body={reasonTemplate}
          style={{ textAlign: "center" }}
          field="approvalStatus"
          header="Status"
          sortable
        >
        </Column>
        <Column
          field="active"
          header="Active"
          style={{ textAlign: "center" }}
          sortable
        ></Column>
      </DataTable>

      <CPPRequestDetails visible={visible} requestDetails={requestDetails} CPPDetails={CPPDetails}></CPPRequestDetails>
      <CPPActionModal visible={actionModalVisible} mode={actionMode} rowId={rowId} CPPActions={CPPActions} handleCallback={Callback} type={1}></CPPActionModal>
      <CPPRequestFormDetails visible={editFormVisible} mode="Edit" showHeader={false} requestDetails={requestDetails} CPPEditForm={CPPEditForm}></CPPRequestFormDetails>
      <div>

        <Dialog
          visible={deleteRecordDialog}
          style={{ width: '32rem' }}
          breakpoints={{ '960px': '75vw', '641px': '90vw' }}
          header="Confirm"
          modal
          footer={deleteRecordDialogFooter}
          onHide={hideDeleteRecordDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{ fontSize: '2rem' }}
            />
            {record && (
              <span style={{ fontSize: '1rem', padding: '5px' }}>
                Are you sure you want to delete client code <b>{record != null && record}</b>?
              </span>
            )}
          </div>
        </Dialog>

      </div>
    </div>
  );
};

export const CppoCodeList = (props: any) => {
  return (
    <>
      {/* <HeaderSection /> */}

      <div className="row m-2 mt-4">
        <div className="col-md-12">
          <CppoRequestList showActions={props?.showbutton} />

        </div>
      </div>
    </>
  );
};
